import { dismiss, warning } from '@valid-eval/shared-react-components';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

type StaleScoresAlertProps = {
  show: boolean;
};

const StaleScoresAlert = ({ show }: StaleScoresAlertProps) => {
  const { t } = useTranslation();
  const alertIdRef = useRef<string | null>(null);

  const dismissAlert = () => {
    if (alertIdRef.current) {
      dismiss(alertIdRef.current);
    }
  };

  useEffect(() => {
    dismissAlert();

    if (show) {
      alertIdRef.current = warning(t('phases.stale_scores_pending', 'Score calculations pending'), {
        icon: 'text-orange01 fa-regular fa-shield-check fa-lg',
        duration: Infinity,
        closable: false,
      });
    }

    return dismissAlert;
  }, [show]);

  return null;
};

export default StaleScoresAlert;
